import Button from '@base/Button/Button';
import { BATCHES_PAGE } from '@constants/appFlyerLinks';
import styled from '@emotion/styled';
import useOneLinkSmartScript from '@hooks/useOneLinkSmartScript';

const ContinueOnApp = styled(Button)`
  width: 100%;
`;

const ContinueOnAppButton = () => {
  const appDownloadLink = useOneLinkSmartScript(BATCHES_PAGE);
  const onClickContinue = () => {
    window.open(appDownloadLink, '_blank');
  };
  return (
    <ContinueOnApp
      onClick={onClickContinue}
      variant="filled"
      label="Continue on the App"
    />
  );
};
export default ContinueOnAppButton;
